export default "__VITE_ASSET__CnPYKadv__"